import { render, staticRenderFns } from "./BidsActModal.vue?vue&type=template&id=736fc8b5&"
import script from "./BidsActModal.vue?vue&type=script&lang=js&"
export * from "./BidsActModal.vue?vue&type=script&lang=js&"
import style0 from "./BidsActModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports